<template>
<div class="sidebar-menu list-unstyled">
  <div @mouseover="itemisActive = true" @mouseout="itemisActive = false"
    :class="{ highlights: ( itemisActive && !item.header && !item.disabled)  }">
    <!-- <div @click="hasClicked = true" :class="{ clicked: hasClicked}"> :class="{ clicked: hasClicked }"> -->
    <div v-if="item.header" class="sidebar-header">
      <!-- <li><i :class=item.icon></i>{{ item.title }}</li> -->
      <li><span class="icon">{{item.icon}}</span>{{ item.title }}</li>
    </div>
    <div v-else-if="item.disabled" class="sidebar-header_disabled">
      <!-- <li><i :class=item.icon></i><router-link to="/india" event="">{{ item.title }}</router-link></li> -->
      <li><span class="icon">{{item.icon}}</span><router-link :to=item.href event="">{{ item.title }}</router-link></li>
    </div>
    <div v-else-if="!item.header && item.href && !item.badge" @mouseout="hasClicked = false" @click="Clicked(item.href)"
      :class="{ clicked: hasClicked }">
        <!-- <li><i :class=item.icon></i><router-link :to=item.href>{{ item.title }}</router-link></li> -->
        <li><span class="icon" :style=item.icon>{{item.icon}}</span><router-link :to=item.href>{{ item.title }}</router-link></li>
    </div>
    <div v-else-if="!item.header && item.badge" @mouseout="hasClicked = false" @click="Clicked(item.href)" :class="{ clicked: hasClicked }">
        <!-- <li><i :class=item.icon></i>{{ item.title }}<span class="sidebar-badges" :to=item.href>{{item.badge.text}}</span></li> -->
        <li><span class="icon">{{item.icon}}</span>{{ item.title }}<span class="sidebar-badges"
          :to=item.href>{{item.badge.text}}</span></li>
    </div>
    <div v-else-if="!item.header && item.child" @click="Clicked(item.href)"
      :class="{ clickedc: hasClicked }">
        <span class="sidebar-arrow"
          :class="hasClicked ? 'sidebar-arrow_open' : 'sidebar-arrow'">
        </span>
        <!-- <li @mouseout="itemisActive = false"><i :class=item.icon></i>{{ item.title}}</li> -->
        <li @mouseout="itemisActive = false"><span class="icon">{{item.icon}}</span>{{ item.title}}</li>
        <div v-if="isCollapsed">
          <sidebar-menu
           v-for="(subItem, index) in item.child"
            :key="index"
            :item="subItem"
          >
            <slot
              slot="dropdown-icon"
              name="dropdown-icon"
            />
          </sidebar-menu>
        </div>
    </div>
    <div v-else-if="item.isToggleButton" @mouseout="hasClicked = false" @click="Clicked(item.href)" :class="{ clicked: hasClicked }">
        <!-- <li><i :class=item.icon></i>{{ item.title }}</li> -->
        <li><span class="icon">{{item.icon}}</span>{{ item.title }}</li>
    </div>
  </div>
  <!-- </div> -->
</div>

</template>
<script>
export default {
  name: "SidebarMenu",
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      itemisActive: false,
      hasClicked: false,
      isCollapsed: false,
    };
  },
  methods: {
    Clicked(path) {
      this.isCollapsed = !this.isCollapsed;
      this.hasClicked = !this.hasClicked;
      this.$router.push(path);
    }
  },
  created() {
    this.hasClicked = false;
  }
};
</script>
<style scoped>
</style>
